// Vendors
import React, { createContext, useContext, useState } from 'react';
// Types
import { FetchErrorContextType } from './types/fetch-error.context.type';

const FetchErrorContext = createContext<FetchErrorContextType>({} as FetchErrorContextType);

const FetchErrorContextProvider = ({ children }: React.PropsWithChildren): React.ReactElement => {
  const [fetching, setFetching] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  return (
    <FetchErrorContext.Provider value={{ error, fetching, setFetching, setError }}>
      {children}
    </FetchErrorContext.Provider>
  );
};

const useFetchErrorContextConsumerHook = (): FetchErrorContextType => useContext(FetchErrorContext);

/* eslint-disable */
const FetchErrorContextConsumerHOC =
  (Component: React.FunctionComponent<any>): React.FunctionComponent<FetchErrorContextType> | any =>
  (props: any): React.ReactElement<React.Provider<FetchErrorContextType>> | any =>
    (
      <FetchErrorContextProvider>
        <Component {...props} />
      </FetchErrorContextProvider>
    );

export {
  useFetchErrorContextConsumerHook,
  FetchErrorContextProvider,
  FetchErrorContextConsumerHOC,
};
